import { render, staticRenderFns } from "./FormResolution.vue?vue&type=template&id=19ab64b3&scoped=true&"
import script from "./FormResolution.vue?vue&type=script&lang=js&"
export * from "./FormResolution.vue?vue&type=script&lang=js&"
import style0 from "./FormResolution.vue?vue&type=style&index=0&id=19ab64b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ab64b3",
  null
  
)

export default component.exports